// extracted by mini-css-extract-plugin
export default {"game-screen":"style_game-screen__Z7dtm"};